<template>
    <div class="sacbod">
        <iframe src="/sac/oup.html"></iframe>
    </div>
</template>

<script>

import ENUMS from '../Enums';
// import Pact from 'pact-lang-api'
// import { get_wallet_manager } from '@/utility'

export default {
    name: ENUMS.VIEWS.SACRIFICE,
    methods: {
    }
    ,
    data() {
        return {
            ENUMS: ENUMS
        };
    },
    components: { }
}

</script>

<style scoped>
.sacbod{
    padding: 2%;
    display: flex;
    justify-content: center;
    align-items: center;
}
iframe{
    border: none;
    width: 960px;
    height: 684px;
    align-self: center;
    justify-self: center;
}
</style>